<ng-template #peachModal let-modal >
    <div class="modal-body">
        <div style="min-height: 90vh; max-height: 90vh; max-width: 100vw; overflow-y: auto; ">
                <allxs-peachpayment (onPaymentInit)="onPeachInit($event)" (requestCancelled)="onPeachCancelled($event)"
                    (requestComplete)="onPeachComplete($event)" (requestFailed)="onPeachFailed($event)" (requestExpired)="onPeachFailed($event)">
                </allxs-peachpayment>
        </div>
    </div>
</ng-template>
